import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { DescodificadorService } from 'src/services/descodificador.service';
import { EstacaoService } from 'src/services/estacao.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { SensorService } from 'src/services/sensor.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-sensor',
    templateUrl: './sensor.component.html',
    styleUrls: ['./sensor.component.scss'],
    standalone: false
})
export class SensorComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  form: FormGroup;
  displayModal: boolean = false;
  loading: boolean = false;
  dropDownDescoficadores: any[] = [];
  dropDownEstacao: any[] = [];
  direitoInserir: boolean = false;
  direitoEditar: boolean = false;
  direitoExcluir: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  /** Modal de exclusão quando há estação vinculada: usuário deve digitar "Excluir transmissor" */
  modalExcluirComEstacao: boolean = false;
  sensorParaExcluir: any = null;
  estacaoRelacionada: { id: number; nome: string } | null = null;
  inputExcluirTransmissor: string = '';
  readonly textoConfirmacaoExclusao = 'Excluir transmissor';

  constructor(
    protected _sensorService: SensorService,
    protected _estacaoService: EstacaoService,
    protected _formBuilder: FormBuilder,
    protected permissaoService: PermissoesService,
    protected _descodificadorService: DescodificadorService,
    protected messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }


ngOnInit(): void {
  this.direitoInserir = this.permissaoService.can('sensores_inserir');
  this.direitoEditar = this.permissaoService.can('sensores_editar');
  this.direitoExcluir = this.permissaoService.can('sensores_excluir');

  this.form = this._formBuilder.group({
    id: [null],
    descricao: [null, Validators.required],
    estacao_id: [null, [Validators.required, this.validarEstacao]],
    identificador: [null, Validators.required],
    tipo_coleta: [null],
  })
  this.listEstacao()
  this.index()
  this.listDescodificadores()
}

  // Validador customizado para estação (rejeita 'null' como string)
  validarEstacao = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === 'null' || value === '') {
      return { required: true };
    }
    return null;
  }

ngAfterViewInit(): void {
  setTimeout(() => {
    this.calculateScrollHeight();
  }, 200);
}

calculateScrollHeight(): void {
  if (this.tableWrapper && this.tableWrapper.nativeElement) {
    const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
    const calculatedHeight = wrapperHeight - 120;
    this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
  }
}

listDescodificadores() {
  this.dropDownDescoficadores = []
  this.dropDownDescoficadores.push({
    value: 'null', label: 'Selecione'
  })
  this._descodificadorService.index().subscribe(json => {
    json.map(item => {
      this.dropDownDescoficadores.push({
        value: item.id, label: item.descricao
      })
    })
    
  })
}

listEstacao(){
  this.dropDownEstacao = []
  this.dropDownEstacao.push({
    value: 'null', label: 'Selecione'
  })
this._estacaoService.lookup().subscribe(json => {
  json.map(item => {
    this.dropDownEstacao.push({
      value: item.id, label: item.descricao
    })
  })
  
})
}
index(){
this._sensorService.index().subscribe(json => {
  this.data = json || [];
  setTimeout(() => {
    this.calculateScrollHeight();
  }, 200);
})
}

openNew(){
  this.form.reset()
  this.displayModal = true
}

edit(event){
  this._sensorService.show(event.id).subscribe(json => {
    this.form.patchValue(json)
    this.displayModal = true
  })
}

save(){
  // Valida o formulário antes de salvar
  if (this.form.invalid) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Preencha todos os campos obrigatórios: Descrição, Estação e Identificador'
    });
    // Marca todos os campos como touched para exibir os erros
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsTouched();
    });
    return;
  }

  this.loading = true
  let form = this.form.value
  let params = {
    descricao: form.descricao,
    estacao_id: form.estacao_id,
    identificador: form.identificador,
    tipo_coleta: form.tipo_coleta,
  }

  if(form.id == null){
this._sensorService.store(params).subscribe(json => {
  this.messageService.add({
    severity: 'success',
    summary: 'Sucesso',
    detail: 'Transmissor criado com sucesso'
  });
  this.index()
this.loading = false
this.displayModal = false
}, err =>{
  this.messageService.add({
    severity: 'error',
    summary: 'Erro',
    detail: 'Erro ao criar transmissor'
  });
  this.loading = false
})
  } else {
this._sensorService.update(params, form.id).subscribe(json => {
  this.messageService.add({
    severity: 'success',
    summary: 'Sucesso',
    detail: 'Transmissor atualizado com sucesso'
  });
  this.index()
  this.loading = false
  this.displayModal = false
}, err =>{
  this.messageService.add({
    severity: 'error',
    summary: 'Erro',
    detail: 'Erro ao atualizar transmissor'
  });
  this.loading = false
})
  }
}

  /**
   * Antes de excluir, chama GET /api/sensores/{id}/estacao-relacionada.
   * Se não houver estação: confirmação simples Sim/Não.
   * Se houver estação: abre modal onde o usuário deve digitar "Excluir transmissor".
   */
  confirmarExclusao(sensor: any): void {
    this._sensorService.getEstacaoRelacionada(sensor.id).subscribe({
      next: (res: any) => {
        const existe = res?.existe === true;
        const estacao = res?.estacao ?? null;
        if (!existe || !estacao) {
          this.confirmarExclusaoSimples(sensor);
        } else {
          this.sensorParaExcluir = sensor;
          this.estacaoRelacionada = estacao;
          this.inputExcluirTransmissor = '';
          this.modalExcluirComEstacao = true;
        }
      },
      error: (err) => {
        const msg = err?.error?.message || 'Sensor não encontrado.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      },
    });
  }

  private confirmarExclusaoSimples(sensor: any): void {
    const descricao = sensor.descricao || `ID ${sensor.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o transmissor "${descricao}" (código ${sensor.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirTransmissor(sensor.id),
    });
  }

  fecharModalExcluirComEstacao(): void {
    this.modalExcluirComEstacao = false;
    this.sensorParaExcluir = null;
    this.estacaoRelacionada = null;
    this.inputExcluirTransmissor = '';
  }

  executarExclusaoComEstacao(): void {
    if (!this.sensorParaExcluir || this.inputExcluirTransmissor !== this.textoConfirmacaoExclusao) return;
    this.excluirTransmissor(this.sensorParaExcluir.id);
    this.fecharModalExcluirComEstacao();
  }

  /**
   * Chama DELETE /api/sensores/{id}. Resposta 204 sucesso, 404 não encontrado.
   */
  private excluirTransmissor(id: number): void {
    this._sensorService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Transmissor excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const msg = err?.error?.message || 'Sensor não encontrado.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg || 'Transmissor não encontrado. Removido da lista.',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg || 'Não foi possível excluir o transmissor.',
          });
        }
      },
    });
  }
}

